export const SET_SUPPLY_USER_MANAGEMENT_FETCHING_FLAG = 'SET_SUPPLY_USER_MANAGEMENT_FETCHING_FLAG';
export const SET_SUPPLY_ADMIN_USERS = 'SET_SUPPLY_ADMIN_USERS';
export const SET_SUPPLY_AGENT_USERS = 'SET_SUPPLY_AGENT_USERS';
export const SET_SUPPLY_SHOW_ADD_USER_MODAL = 'SET_SUPPLY_SHOW_ADD_USER_MODAL';
export const SET_SUPPLY_ADD_USER_MODAL_TYPE = 'SET_SUPPLY_ADD_USER_MODAL_TYPE';
export const SET_SUPPLY_ALLOWED_JOB_TITLE = 'SET_SUPPLY_ALLOWED_JOB_TITLE';
export const SET_SUPPLY_SHOW_ADD_JOB_TITLE_MODAL = 'SET_SUPPLY_SHOW_ADD_JOB_TITLE_MODAL';
